const aaa = [
    {
        path: "saleOrderSee",
        component: () => import("@/views/dingdan/order/saleOrder/see.vue"),
        meta: { title: '订单' },
    },
    {
        path: "dingjinOrderList",
        component: () => import("@/views/dingdan/order/saleOrder/dingjinOrderList.vue"),
        meta: { keepAlive: false },
    },
    {
        path: "huotiOrderList",
        component: () => import("@/views/dingdan/order/saleOrder/huotiOrderList.vue"),
        meta: { keepAlive: true },
    },
   
    {
        path: "saleOrderList",
        component: () => import("@/views/dingdan/order/saleOrder/list.vue"),
        meta: { title: '消费订单', keepAlive: true },
    },
   
    
]
export default aaa;